import React from 'react'
import PropTypes from 'prop-types'
import PlanStatusBadge from './badges/PlanStatusBadge'
import { formatPlanDate } from './helpers'
import SeDebugControl from './seDebug/SeDebugControl'

function PlanHeader ({ plan, title, statusStyleOverrides }) {
  const lastReviewed = formatPlanDate(plan?.metadata?.lastReviewedDate)

  return (
    <div className='flex items-center justify-between mb-3 gap-2'>
      <div className='flex items-center gap-2' style={{ minWidth: 0 }}>
        <h3 className='font-size-lg font-medium m-0' style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {title}
        </h3>
        <SeDebugControl />
      </div>
      <div className='flex items-center gap-2 font-size-xs' style={{ color: 'var(--text-color-subtle)', flexShrink: 0 }}>
        {plan?.status ? <PlanStatusBadge status={plan.status} statusStyleOverrides={statusStyleOverrides} /> : null}
        {lastReviewed ? <span>Last reviewed {lastReviewed}</span> : null}
      </div>
    </div>
  )
}

PlanHeader.propTypes = {
  plan: PropTypes.shape({
    name: PropTypes.string,
    status: PropTypes.string,
    metadata: PropTypes.object
  }),
  title: PropTypes.string,
  statusStyleOverrides: PropTypes.object
}

export default PlanHeader
